export default __webpack_public_path__ + "static/media/jesica.07d48970.jpg";